//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import styles from './style.module.scss';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Check } from 'src/onboarding/components/ui/check/Check';
import { Option } from 'src/onboarding/components/ui/check/Option';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import image from '../../assets/images/transition-with-image.png';
import Button from 'src/onboarding/components/ui/button/Button';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  const isFirst = currentIndex === 0;

  return (
    <div className={`page ${styles.top}`}>
      {!isFirst && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.flexible-meal-transition.title')}</Title>
        <Text semibold className={styles.description}>
          {t('onboarding.flexible-meal-transition.text')}
        </Text>
      </div>
      <div className={styles.image} />
      <div className={'next-wrapper'}>
        <Button
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'flexible-meal-transition',
            });
            onNext();
          }}
          title={t('onboarding.flexible-meal-transition.continue')}
        />
      </div>
    </div>
  );
}
export default Page;
